import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useMemo, useRef } from 'react';
import config from 'config';
import OneTrustSnippet from '../OneTrustSnippet';
import SegmentSnippet from '../SegmentSnippet';

function SetupSegmentWithActiveGroups(_ref) {
  var activeGroups = _ref.activeGroups;
  var hasEverConsented = useRef(false);
  var segmentMapping = config.get('public.oneTrust.segmentMapping');
  var segmentCategories = useMemo(function () {
    var _activeCategories;

    var activeCategories = [];

    if (!activeGroups || !segmentMapping) {
      return activeCategories;
    }

    activeCategories = (_activeCategories = activeCategories).concat.apply(_activeCategories, _toConsumableArray(activeGroups.map(function (activeGroup) {
      return segmentMapping[activeGroup];
    }))).filter(Boolean);

    if (activeCategories.length) {
      hasEverConsented.current = true;
    }

    return activeCategories;
  }, [activeGroups, segmentMapping]); // If the user has ever consented to any OneTrust consent level, we'll render
  // the Segment snippet.
  // In the scenario where consent for Segment was given and is taken away,
  // `SegmentSnippet.Setup` needs to continue to be rendered because it
  // will reload the page when the active integrations change.

  if (hasEverConsented.current) {
    return /*#__PURE__*/React.createElement(SegmentSnippet.Setup, {
      activeCategories: segmentCategories
    });
  }

  return null;
}
/**
 * This component will handle setting up Segment based on OneTrust consent levels,
 * and will only render the Segment snippet if the user has ever consented to any
 * OneTrust consent level.
 * Usage of this assumes that `<OneTrustSnippet />` is rendered _before_ this component.
 */


function OneTrustSetupWithSegment() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SegmentSnippet, {
    autoLoad: false
  }), /*#__PURE__*/React.createElement(OneTrustSnippet.Setup, null, function (_ref2) {
    var activeGroups = _ref2.activeGroups;
    return /*#__PURE__*/React.createElement(SetupSegmentWithActiveGroups, {
      activeGroups: activeGroups
    });
  }));
}

export default OneTrustSetupWithSegment;